import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./api/auth/auth-config";

export const msalInstance = new PublicClientApplication(msalConfig);
